(function() {
  if (window.__yonderCartDrawerInit) return;
  window.__yonderCartDrawerInit = true;

  var overlay     = document.getElementById('yonder-cart-overlay');
  var drawer      = document.getElementById('yonder-cart-drawer');
  var itemsEl     = document.getElementById('ycdItems');
  var emptyEl     = document.getElementById('ycdEmpty');
  var footerEl    = document.getElementById('ycdFooter');
  var loadEl      = document.getElementById('ycdLoading');
  var shipMsgEl   = document.getElementById('ycdShipMsg');
  var shipFillEl  = document.getElementById('ycdShipFill');
  var shipTrackEl = document.getElementById('ycdShipTrack');
  var subtotalEl      = document.getElementById('ycdSubtotalAmt');
  var subtotalCmpEl   = document.getElementById('ycdSubtotalCompare');
  var countEl     = document.getElementById('ycdCount');
  var savingsEl   = document.getElementById('ycdSavings');
  var savingsPill = document.getElementById('ycdSavingsPill');
  var discInput   = document.getElementById('ycdDiscountInput');
  var discBtn     = document.getElementById('ycdDiscountBtn');
  var discMsg     = document.getElementById('ycdDiscountMsg');

  /* ── "You'll also love" recommendations config ──
     Values arrive from the section's Liquid via an inline config object emitted
     immediately before this (external) script's tag — see sections/cart-drawer.liquid.
     The literal fallbacks below mirror the Liquid `default:` filters exactly and
     only apply if the config script somehow did not run. (2026-08-15) */
  var __ycdCfg = window.__yonderCartDrawerCfg || {};
  var REC_ENABLED = __ycdCfg.recEnabled !== false;
  var REC_LIMIT   = (__ycdCfg.recLimit == null ? 3 : __ycdCfg.recLimit);
  var REC_INTENT  = __ycdCfg.recIntent || 'related';
  var REC_PIN_ENABLED = __ycdCfg.recPinEnabled !== false;
  var REC_PIN_HANDLE  = __ycdCfg.recPinHandle || 'grass-fed-collagen-peptides-flavorless-454g';
  var REC_SORT    = __ycdCfg.recSort || 'price_asc';
  var REC_SHIP_BADGE = __ycdCfg.recShipBadge !== false;
  var REC_SEED_MAX = 3;              /* how many cart products we'll pull suggestions from */
  /* Catalog fallback, rendered server-side. Shopify's recommendation engine can hand back
     fewer than REC_LIMIT usable products, and there was no path to top the tray up — so a
     product removed from the cart never reappeared as a suggestion if the engine had not
     related it to whatever was left. */
  var REC_FALLBACK = __ycdCfg.recFallback || [];
  var recHandleCache = {};
  var recCache = {};
  var recPinCache = null;
  var recRenderedKey = '';           /* skip re-drawing when the suggested set hasn't changed */
  var recHoldUntil = 0;              /* brief pause so "Added ✓" is visible before the row leaves */
  var recHoldTimer = null;
  var recLastCart = null;
  var recSkelTimer = null;
  var recSeenKey = '';               /* last impression reported to analytics */

  /* Free-shipping maths is shared: the progress bar draws with it and the upsell
     uses it to flag which suggestion would cross the line */
  var FREE_SHIP_CENTS = 9900;
  var recShipGap = 0;                /* cents still needed; 0 when free shipping isn't in play */

  var recHeadEl   = document.getElementById('ycdRecommendHead');
  var recLiveEl   = document.getElementById('ycdLive');
  var REC_HEADING_DEFAULT = recHeadEl ? recHeadEl.textContent : '';

  /* ── Helpers ── */
  function fmt(cents) {
    if (!cents && cents !== 0) return '';
    return '$' + (cents / 100).toFixed(2);
  }
  function lockBody(lock) { document.body.style.overflow = lock ? 'hidden' : ''; }

  /* One-time purchase subtotal, with the multi-pack tier discounts Shopify doesn't apply.
     Used by both the free-shipping bar and the upsell's "unlocks free shipping" flag. */
  function ycdOtpTotals(cart) {
    var otpTotal = 0, hasSub = false;
    (cart && cart.items ? cart.items : []).forEach(function(item) {
      if (item.selling_plan_allocation) { hasSub = true; return; }
      var fspVar  = item.variant_title || '';
      var fspPM   = fspVar.match(/(\d+)\s*-?\s*pack/i);
      var fspPack = fspPM ? parseInt(fspPM[1], 10) : 1;
      var fspFl   = (item.product_title || '').toLowerCase().indexOf('flavorless') !== -1;
      var fspEff  = fspPack * item.quantity;
      var fspDisc = 0;
      if (fspFl) {
        if      (fspEff >= 3) fspDisc = 0.10;
        else if (fspEff >= 2) fspDisc = 0.05;
      } else {
        if      (fspEff >= 5) fspDisc = 0.10;
        else if (fspEff >= 3) fspDisc = 0.05;
      }
      var fspFull = ((item.compare_at_price && item.compare_at_price > item.original_price)
        ? item.compare_at_price : item.original_price) * item.quantity;
      otpTotal += fspDisc > 0 ? Math.round(fspFull * (1 - fspDisc)) : item.final_line_price;
    });
    return { otpTotal: otpTotal, hasSub: hasSub, hasOtp: otpTotal > 0 };
  }

  /* Analytics — every sink is optional, so a missing platform can't break the drawer.
     GA4 ecommerce naming so it maps straight into existing reports. */
  function recTrack(eventName, payload) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        var dl = { event: eventName };
        for (var k in payload) { if (Object.prototype.hasOwnProperty.call(payload, k)) dl[k] = payload[k]; }
        window.dataLayer.push(dl);
      }
    } catch (e) {}
    try {
      if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['track', 'Cart Drawer Upsell ' + eventName, payload]);
      }
    } catch (e) {}
    /* Anything else on the page can listen without us knowing about it */
    try { document.dispatchEvent(new CustomEvent('yonder:upsell:' + eventName, { detail: payload })); } catch (e) {}
  }

  function recAnnounce(msg) {
    if (!recLiveEl) return;
    recLiveEl.textContent = '';
    setTimeout(function() { recLiveEl.textContent = msg; }, 60);
  }

  /* ── Open / Close ── */
  var ycdCartOpen = false;

  function gorgiasHide(hide) {
    document.querySelectorAll('iframe[src*="gorgias"], iframe[id*="gorgias"], iframe[name*="gorgias"], iframe[title*="Gorgias"]').forEach(function(el) {
      el.style.setProperty('display', hide ? 'none' : '', 'important');
    });
  }

  function close() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    lockBody(false);
    gorgiasHide(false);
  }
  function open() {
    drawer.classList.add('open');
    overlay.classList.add('open');
    lockBody(true);
    gorgiasHide(true);
    recSeenKey = '';   /* each drawer open counts as a fresh impression */
    fetchCart();
  }

  /* ── Single fetch queue — prevents race conditions ── */
  var fetching = false;
  var refetch  = false;

  function fetchCart() {
    if (fetching) { refetch = true; return; }
    fetching = true;

    /* Dim items during reload instead of full spinner for speed */
    Array.from(itemsEl.children).forEach(function(c) {
      if (!c.classList.contains('ycd-empty')) c.style.opacity = '0.4';
    });

    fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        fetching = false;
        renderCart(cart);
        if (refetch) { refetch = false; fetchCart(); }
      })
      .catch(function() {
        fetching = false;
        loadEl.classList.remove('show');
      });
  }

  /* ── Recommendations: fetch + render cards ── */
  function ycdEsc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  /* The item list scrolls, so a dropdown on the last row can open below the fold.
     Nudge the list down just enough to show the whole menu. */
  function ycdRevealDropdown(dd) {
    var scroller = document.getElementById('ycdItems');
    var trig = dd.querySelector('.ycd-rvd-trigger');
    var list = dd.querySelector('.ycd-rvd-list');
    if (!scroller || !trig || !list) return;
    var need   = Math.min(list.scrollHeight, 240);
    var bottom = trig.getBoundingClientRect().bottom + need + 12;
    var limit  = scroller.getBoundingClientRect().bottom;
    if (bottom > limit) {
      try { scroller.scrollBy({ top: bottom - limit, behavior: 'smooth' }); }
      catch (err) { scroller.scrollTop += (bottom - limit); }
    }
  }
  /* Single place that opens/closes a size dropdown, so aria-expanded can never
     drift out of sync with the .open class */
  function ycdSetRvd(dd, want) {
    if (!dd) return;
    dd.classList.toggle('open', !!want);
    var trig = dd.querySelector('.ycd-rvd-trigger');
    if (trig) trig.setAttribute('aria-expanded', want ? 'true' : 'false');
    if (want) ycdRevealDropdown(dd);
    else dd.querySelectorAll('.ycd-rvd-list li.ycd-kb').forEach(function(l) { l.classList.remove('ycd-kb'); });
  }
  /* Cheapest buyable variant — what the row defaults to and what we price against */
  function recDefVariant(p) {
    var variants = (p.variants || []).filter(function(v){ return v.available; });
    if (!variants.length) variants = (p.variants || []);
    return variants[0] || {};
  }
  /* True when adding this product would push the one-time subtotal past the threshold */
  function recClosesGap(p) {
    if (!REC_SHIP_BADGE || recShipGap <= 0) return false;
    var def = recDefVariant(p);
    var price = def.price != null ? def.price : p.price;
    return typeof price === 'number' && price >= recShipGap;
  }

  /* Free shipping is already stated by the green progress bar and by the tray heading.
     A per-row badge only earns its place when it discriminates, so: at most one row
     ever carries it (the cheapest that clears the gap), and no row carries it when
     every row would. Runs set-wide after paint and after any variant change. */
  /* Three independent sources feed the tray — the recommendation engine, the pinned
     product and the catalog top-up. Each has its own guard, but a guard that is missed
     in one of them should not be able to put the same row on screen twice, so every set
     passes through here before it renders. Title is checked as well as id because the
     catalog carries near-identical records (three "…Peptides Flavorless" products), and
     two of those side by side reads as a duplicate to a customer whatever their ids say. */
  function recDedupe(list) {
    var byId = {}, byTitle = {}, out = [];
    (list || []).forEach(function(p) {
      if (!p || p.id == null) return;
      var t = String(p.title || '').trim().toLowerCase().replace(/\s+/g, ' ');
      if (byId[p.id] || (t && byTitle[t])) return;
      byId[p.id] = true; if (t) byTitle[t] = true;
      out.push(p);
    });
    return out;
  }

  function recSyncShipBadges() {
    var g = document.getElementById('ycdRecommendGrid');
    if (!g) return;
    var cards = Array.prototype.slice.call(g.querySelectorAll('.ycd-rec-card'));
    if (!cards.length) return;
    var target = null, targetPrice = Infinity, qualCount = 0;
    var live = REC_SHIP_BADGE && recShipGap > 0;
    cards.forEach(function(c) {
      var price = parseFloat(c.getAttribute('data-price'));
      if (!live || !isFinite(price) || price < recShipGap) return;
      qualCount++;
      if (price < targetPrice) { targetPrice = price; target = c; }
    });
    if (qualCount === cards.length) target = null;
    cards.forEach(function(c) {
      var show = (c === target);
      c.classList.toggle('ycd-rec-qualifies', show);
      var badge = c.querySelector('.ycd-rec-ship');
      if (show && !badge) {
        var body = c.querySelector('.ycd-rec-body');
        if (!body) return;
        badge = document.createElement('span');
        badge.className = 'ycd-rec-ship';
        badge.textContent = '🚚 Unlocks free shipping';
        body.insertBefore(badge, body.firstChild);
      } else if (!show && badge) {
        badge.parentNode.removeChild(badge);
      }
    });
  }

  function buildRecCard(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var variants = (p.variants || []).filter(function(v){ return v.available; });
    var allVariants = p.variants || [];
    if (!variants.length) variants = allVariants;
    var def = variants[0] || {};
    var selHtml = '';
    if (allVariants.length > 1) {
      var liHtml = allVariants.map(function(v){
        var out  = v.available === false;
        var isDef = v.id === def.id;
        return '<li role="option" class="' + (isDef ? 'active' : '') + '"' +
          ' aria-selected="' + (isDef ? 'true' : 'false') + '"' +
          (out ? ' aria-disabled="true"' : '') +
          ' data-variant="' + v.id +
          '" data-price="' + v.price + '" data-compare="' + (v.compare_at_price || 0) + '">' +
          ycdEsc(v.title) + (out ? ' — sold out' : '') + '</li>';
      }).join('');
      selHtml =
        '<div class="ycd-rvd">' +
          '<button type="button" class="ycd-rvd-trigger" aria-haspopup="listbox" aria-expanded="false"' +
            ' aria-label="Choose size for ' + ycdEsc(p.title) + '">' +
            '<span class="ycd-rvd-cur">' + ycdEsc(def.title) + '</span>' +
            '<svg class="ycd-rvd-chevron" width="18" height="18" viewBox="0 0 22 22" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
              '<circle cx="11" cy="11" r="10" stroke="rgba(255,255,255,0.55)" stroke-width="1.5"/>' +
              '<path d="M7.5 9.5L11 13L14.5 9.5" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</button>' +
          '<ul class="ycd-rvd-list" role="listbox" aria-label="' + ycdEsc(p.title) + ' size">' + liHtml + '</ul>' +
        '</div>';
    }
    var defCompare = (def.compare_at_price && def.compare_at_price > def.price) ? def.compare_at_price : 0;
    var priceHtml = '<span class="ycd-rec-amt">' + fmt(def.price != null ? def.price : p.price) + '</span>' +
      (defCompare ? '<span class="ycd-rec-compare">' + fmt(defCompare) + '</span>' : '');
    var shipHtml  = '';           /* badge is applied set-wide by recSyncShipBadges() */
    var defPrice  = def.price != null ? def.price : p.price;
    var url = ycdEsc(p.url);
    return '<div class="ycd-rec-card"' +
        ' data-product="' + p.id + '" data-price="' + (defPrice || 0) + '" data-title="' + ycdEsc(p.title) + '">' +
        '<a class="ycd-rec-imglink" href="' + url + '" tabindex="-1" aria-hidden="true">' +
          '<img class="ycd-rec-img" src="' + ycdEsc(img) + '" alt="" width="76" height="76" loading="lazy" decoding="async">' +
        '</a>' +
        '<div class="ycd-rec-body">' +
          shipHtml +
          '<a class="ycd-rec-title" href="' + url + '">' + ycdEsc(p.title) + '</a>' +
          '<div class="ycd-rec-price">' + priceHtml + '</div>' +
          '<div class="ycd-rec-actions">' +
            selHtml +
            '<button type="button" class="ycd-rec-add" data-variant="' + (def.id || '') + '"' +
              ' aria-label="Add ' + ycdEsc(p.title) + ' to cart">Add</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function recSkeletonHtml(n) {
    var row =
      '<div class="ycd-rec-card ycd-rec-skel" aria-hidden="true">' +
        '<div class="ycd-skel-box ycd-skel-img"></div>' +
        '<div class="ycd-rec-body">' +
          '<div class="ycd-skel-box ycd-skel-line w70"></div>' +
          '<div class="ycd-skel-box ycd-skel-line w35"></div>' +
          '<div class="ycd-skel-box ycd-skel-line tall"></div>' +
        '</div>' +
      '</div>';
    var out = '';
    for (var i = 0; i < n; i++) out += row;
    return out;
  }
  /* Cart-aware upsell: never suggests something that's already in the cart, and walks
     every product in the cart for suggestions so the list stays full as long as it can.
     When the cart already holds everything we'd suggest, the block hides itself. */
  function loadRecommendations(cart) {
    if (!REC_ENABLED) return;
    var recEl = document.getElementById('ycdRecommend');
    var grid  = document.getElementById('ycdRecommendGrid');
    if (!recEl || !grid) return;
    recLastCart = cart;
    if (!cart.items || !cart.items.length) { hideRec(); return; }

    /* Just added something — let the confirmation show before the row disappears */
    var nowTs = Date.now();
    if (nowTs < recHoldUntil) {
      if (recHoldTimer) clearTimeout(recHoldTimer);
      recHoldTimer = setTimeout(function() {
        recHoldTimer = null;
        if (recLastCart) loadRecommendations(recLastCart);
      }, (recHoldUntil - nowTs) + 40);
      return;
    }

    var inCart = {};
    var seeds  = [];
    cart.items.forEach(function(i) {
      if (!inCart[i.product_id]) { inCart[i.product_id] = true; seeds.push(i.product_id); }
    });
    seeds = seeds.slice(0, REC_SEED_MAX);

    function clearSkel() {
      if (recSkelTimer) { clearTimeout(recSkelTimer); recSkelTimer = null; }
    }
    function hideRec() { clearSkel(); recEl.style.display = 'none'; recRenderedKey = ''; }

    /* Placeholder rows, but only if the fetch is actually slow — a warm cache
       resolves in a microtask and the shimmer never gets a chance to flash */
    if (!recRenderedKey && !recSkelTimer) {
      recSkelTimer = setTimeout(function() {
        recSkelTimer = null;
        if (recRenderedKey) return;
        recEl.style.display = '';
        grid.innerHTML = recSkeletonHtml(REC_LIMIT);
      }, 220);
    }

    function usable(p) {
      return !!p && p.available !== false && !inCart[p.id] &&
             String(p.handle || '').indexOf('gift-card') === -1;
    }

    /* Deliberate order instead of whatever Shopify's algorithm happened to return.
       Qualifying rows float to the top afterwards, so the sort must be stable. */
    function recSorted(list) {
      var out = list.slice();
      if (REC_SORT === 'price_asc' || REC_SORT === 'price_desc') {
        var dir = REC_SORT === 'price_desc' ? -1 : 1;
        out.sort(function(a, b) {
          var pa = recDefVariant(a).price, pb = recDefVariant(b).price;
          if (pa == null) pa = a.price; if (pb == null) pb = b.price;
          return ((pa || 0) - (pb || 0)) * dir;
        });
      }
      /* One nudge to free shipping beats any price order */
      out.sort(function(a, b) { return (recClosesGap(b) ? 1 : 0) - (recClosesGap(a) ? 1 : 0); });
      return out;
    }

    function paint(out) {
      clearSkel();
      if (!out.length) { hideRec(); return; }
      recEl.style.display = '';
      /* recShipGap is in the key so the "unlocks free shipping" flag refreshes
         when quantities change even though the suggested products don't */
      var key = out.map(function(p) { return p.id; }).join(',') + '|' + recShipGap + '|' + REC_SORT;
      if (key === recRenderedKey && grid.children.length === out.length) return;
      recRenderedKey = key;
      grid.innerHTML = out.map(buildRecCard).join('');
      recSyncShipBadges();

      if (recHeadEl) {
        var anyQualifies = out.some(recClosesGap);
        recHeadEl.textContent = anyQualifies
          ? 'Add One More For Free Shipping'
          : REC_HEADING_DEFAULT;
      }

      /* Impression — once per distinct set, not once per re-render */
      if (key !== recSeenKey) {
        recSeenKey = key;
        recTrack('view_item_list', {
          item_list_id: 'cart_drawer_upsell',
          item_list_name: 'Cart Drawer Upsell',
          items: out.map(function(p, i) {
            var dv = recDefVariant(p);
            return {
              item_id: String(p.id),
              item_name: p.title,
              item_variant: dv.title || '',
              price: (dv.price != null ? dv.price : p.price || 0) / 100,
              index: i
            };
          })
        });
      }
    }

    function fetchRelated(seed) {
      if (recCache[seed]) return Promise.resolve(recCache[seed]);
      return fetch(window.Shopify.routes.root + 'recommendations/products.json?product_id=' + seed +
                   '&limit=10&intent=' + REC_INTENT, { cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(data) { recCache[seed] = data.products || []; return recCache[seed]; })
        .catch(function() { recCache[seed] = []; return []; });
    }

    /* The featured product is only used to top up a short list — never forced in */
    function withPinned(cb) {
      if (!REC_PIN_ENABLED || !REC_PIN_HANDLE) { cb(null); return; }
      /* The pinned product is discarded when it is already pooled or in the cart —
         resolve its id from the server-rendered catalog and skip the fetch entirely. */
      for (var pi = 0; pi < REC_FALLBACK.length; pi++) {
        if (REC_FALLBACK[pi].h !== REC_PIN_HANDLE) continue;
        if (inCart[REC_FALLBACK[pi].id] || seen[REC_FALLBACK[pi].id]) { cb(null); return; }
        break;
      }
      if (recPinCache !== null) { cb(recPinCache || null); return; }
      fetch(window.Shopify.routes.root + 'products/' + REC_PIN_HANDLE + '.js', { cache: 'no-store' })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(p) { recPinCache = p || false; cb(p || null); })
        .catch(function() { recPinCache = false; cb(null); });
    }

    /* Gather a pool wider than we'll show, so the sort has something to choose
       between — otherwise "cheapest first" just reorders whatever arrived first */
    /* Cap the target at what the catalog can actually supply. The old fixed target of 9
       is unreachable on a small catalog, so the short-pool branch fired on every open —
       which meant the pin fetch always ran and the fallback walk always ran after it. */
    var recAvail = REC_FALLBACK.filter(function(f) { return !inCart[f.id]; });
    var REC_POOL = Math.min(Math.max(REC_LIMIT * 3, 9), recAvail.length || REC_LIMIT);
    var seen = {};
    function collect(idx, acc) {
      if (acc.length >= REC_POOL || idx >= seeds.length) return Promise.resolve(acc);
      return fetchRelated(seeds[idx]).then(function(list) {
        (list || []).forEach(function(p) {
          if (acc.length >= REC_POOL || seen[p.id] || !usable(p)) return;
          seen[p.id] = true;
          acc.push(p);
        });
        return collect(idx + 1, acc);
      });
    }

    function fetchByHandle(h) {
      if (recHandleCache[h] !== undefined) return Promise.resolve(recHandleCache[h]);
      return fetch(window.Shopify.routes.root + 'products/' + h + '.js', { cache: 'no-store' })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(p) { recHandleCache[h] = p || null; return recHandleCache[h]; })
        .catch(function() { recHandleCache[h] = null; return null; });
    }

    /* Fill any shortfall from the catalog, in catalog order. Filter by id first so
       products already pooled or in the cart cost nothing, then fetch whatever is left
       concurrently — the previous version issued one blocking request per catalog entry,
       including for products it was about to throw away. */
    function recTopUp(acc) {
      if (acc.length >= REC_LIMIT || !REC_FALLBACK.length) return Promise.resolve(acc);
      var need = REC_LIMIT - acc.length;
      /* A couple spare in case one is sold out — they run in parallel, so they cost no
         extra wall-clock, only a request each. */
      var cands = REC_FALLBACK.filter(function(f) {
        return !seen[f.id] && !inCart[f.id];
      }).slice(0, need + 2);
      if (!cands.length) return Promise.resolve(acc);
      return Promise.all(cands.map(function(f) { return fetchByHandle(f.h); }))
        .then(function(list) {
          list.forEach(function(p) {
            if (acc.length >= REC_LIMIT) return;
            if (p && !seen[p.id] && usable(p)) { seen[p.id] = true; acc.push(p); }
          });
          return acc;
        });
    }

    collect(0, []).then(function(acc) {
      if (acc.length >= REC_POOL || !REC_PIN_ENABLED) return acc;
      return new Promise(function(resolve) {
        withPinned(function(pinned) {
          /* Must mark it seen — the catalog top-up runs after this and reads `seen`
             to decide what is still missing. Without this it re-adds the pin. */
          if (pinned && !seen[pinned.id] && usable(pinned)) { seen[pinned.id] = true; acc.push(pinned); }
          resolve(acc);
        });
      });
    }).then(recTopUp).then(function(acc) {
      paint(recSorted(recDedupe(acc)).slice(0, REC_LIMIT));
    });
  }

  /* ── Render ── */
  function renderCart(cart) {
    /* Safety guard — malformed response means re-fetch, never show empty incorrectly */
    if (!cart || !Array.isArray(cart.items)) { fetchCart(); return; }

    /* Clear (preserve empty state + recommendations block) */
    Array.from(itemsEl.children).forEach(function(c) {
      if (!c.classList.contains('ycd-empty') && c.id !== 'ycdRecommend') itemsEl.removeChild(c);
    });
    emptyEl.classList.remove('show');

    /* Badge = total units in cart */
    countEl.textContent = cart.item_count;
    syncNav(cart.item_count);

    if (!cart.items || cart.items.length === 0) {
      emptyEl.classList.add('show');
      footerEl.style.display = 'none';
      shipTrackEl.style.display = 'none';
      shipMsgEl.innerHTML = '';
      document.getElementById('ycdShipBar').style.display = 'none';
      var recElEmpty = document.getElementById('ycdRecommend');
      if (recElEmpty) recElEmpty.style.display = 'none';
      recRenderedKey = '';
      return;
    }

    /* Render items */
    cart.items.forEach(function(item) {
      /* Subscriptions: expand into one card per unit so each can be removed individually */
      if (item.selling_plan_allocation && item.quantity > 1) {
        for (var q = 0; q < item.quantity; q++) itemsEl.appendChild(buildItem(item));
      } else {
        itemsEl.appendChild(buildItem(item));
      }
    });

    /* Free-shipping maths runs first: the upsell needs the gap so it can flag which
       suggestion would cross the line, and the progress bar below reuses the same numbers */
    var shipTotals = ycdOtpTotals(cart);
    recShipGap = (shipTotals.hasOtp && shipTotals.otpTotal < FREE_SHIP_CENTS)
      ? (FREE_SHIP_CENTS - shipTotals.otpTotal) : 0;

    /* Keep the recommendations block pinned to the bottom of the scroll area, then fill it */
    var recEl = document.getElementById('ycdRecommend');
    if (recEl) { recEl.style.opacity = ''; itemsEl.appendChild(recEl); }
    loadRecommendations(cart);

    /* Savings calculation.
       For subscriptions: compare_at_price (per unit) is full retail.
       For OTP multi-packs: compute tier discount client-side since Shopify doesn't apply it.
       We sum the discounted OTP prices + sub prices to get cartDisplayTotal, then compare
       against full retail to show true savings. */
    var cartDisplayTotal = 0;
    var cartFullTotal    = 0;
    (cart.items || []).forEach(function(item) {
      if (item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price) {
        var subFull = item.selling_plan_allocation.compare_at_price * item.quantity;
        cartFullTotal    += subFull;
        cartDisplayTotal += item.final_line_price;
      } else {
        /* OTP — determine pack tier discount */
        var otpFullUnit2   = (item.compare_at_price && item.compare_at_price > item.original_price)
          ? item.compare_at_price : item.original_price;
        var otpFullLine2   = otpFullUnit2 * item.quantity;
        var otpVarTitle2   = item.variant_title || '';
        var otpPack2       = otpVarTitle2.match(/(\d+)\s*-?\s*pack/i);
        var otpPackSize2   = otpPack2 ? parseInt(otpPack2[1], 10) : 1;
        var otpFlavor2     = (item.product_title || '').toLowerCase().indexOf('flavorless') !== -1;
        var effectivePacks2 = otpPackSize2 * item.quantity;
        var otpDiscPct2    = 0;
        if (otpFlavor2) {
          if      (effectivePacks2 >= 3) otpDiscPct2 = 0.10;
          else if (effectivePacks2 >= 2) otpDiscPct2 = 0.05;
        } else {
          if      (effectivePacks2 >= 5) otpDiscPct2 = 0.10;
          else if (effectivePacks2 >= 3) otpDiscPct2 = 0.05;
        }
        cartFullTotal    += otpFullLine2;
        cartDisplayTotal += otpDiscPct2 > 0 ? Math.round(otpFullLine2 * (1 - otpDiscPct2)) : item.final_line_price;
      }
    });

    /* Override the subtotal display with our tier-adjusted total */
    subtotalEl.textContent = fmt(cartDisplayTotal);

    var originalTotal = cartFullTotal;

    if (originalTotal > cartDisplayTotal) {
      subtotalCmpEl.textContent = fmt(originalTotal);
      subtotalCmpEl.style.display = '';
      savingsPill.textContent = 'You saved ' + fmt(originalTotal - cartDisplayTotal) + '!!!';
      savingsEl.classList.add('show');
    } else {
      subtotalCmpEl.style.display = 'none';
      savingsEl.classList.remove('show');
    }

    /* -- Free shipping progress bar: OTP total only (shared with the upsell) -- */
    document.getElementById('ycdShipBar').style.display = '';
    var otpTotal = shipTotals.otpTotal;
    var hasSub   = shipTotals.hasSub;
    var hasOtp   = shipTotals.hasOtp;
    /* Show/hide free shipping badge on all OTP cards based on cart total */
    itemsEl.querySelectorAll('.ycd-otp-free-ship').forEach(function(el) {
      el.style.display = (hasOtp && otpTotal >= FREE_SHIP_CENTS) ? '' : 'none';
    });
    if (!hasOtp && hasSub) {
      shipMsgEl.innerHTML = '\u2713 Free shipping on your subscription!';
      shipTrackEl.style.display = 'none';
    } else if (hasOtp && otpTotal >= FREE_SHIP_CENTS) {
      shipMsgEl.innerHTML = '\u2713 You\'ve unlocked free shipping!';
      shipFillEl.style.width = '100%';
      shipTrackEl.style.display = 'block';
    } else if (hasOtp) {
      var fspRemaining = FREE_SHIP_CENTS - otpTotal;
      var fspPct = Math.min(99, Math.round((otpTotal / FREE_SHIP_CENTS) * 100));
      var truckSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><rect x="1" y="3" width="15" height="13" rx="1"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
      shipMsgEl.innerHTML = truckSvg + 'Add <strong>$' + (fspRemaining / 100).toFixed(2) + '</strong> more for free shipping';
      shipFillEl.style.width = fspPct + '%';
      shipTrackEl.style.display = 'block';
    } else {
      shipMsgEl.innerHTML = '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"flex-shrink:0;\"><rect x=\"1\" y=\"3\" width=\"15\" height=\"13\" rx=\"1\"/><polygon points=\"16 8 20 8 23 11 23 16 16 16 16 8\"/><circle cx=\"5.5\" cy=\"18.5\" r=\"2.5\"/><circle cx=\"18.5\" cy=\"18.5\" r=\"2.5\"/></svg>Free shipping on one-time purchases over $99';
      shipTrackEl.style.display = 'none';
    }

    footerEl.style.display = 'block';
  }

  /* ── Build one item card ── */
  function buildItem(item) {
    var el    = document.createElement('div');
    var isSub = !!item.selling_plan_allocation;
    el.className = 'ycd-item';
    el.setAttribute('data-key',      item.key);
    el.setAttribute('data-qty',      item.quantity);
    el.setAttribute('data-unit',     item.final_price);
    el.setAttribute('data-original', item.original_price); /* compare-at per unit */

    var img          = (item.featured_image && item.featured_image.url) ? item.featured_image.url : item.image;
    var variantBadge = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<span class="ycd-item-variant">' + item.variant_title + '</span>' : '';

    /* ── Shared pack info ── computed once, used for OTP price / upsell save / compare pill
       Sub first-order discount tiers:
         Flavorless: 1-pack=20%, 2-pack=25%, 3-pack=30%
         Flavored:   1-pack=20%, 3-pack=25%, 5-pack=30%
       OTP discount tiers:
         Flavorless: 2-pack=5%, 3-pack=10%
         Flavored:   3-pack=5%, 5-pack=10%                                         */
    var packVarTitle  = item.variant_title || '';
    var packMatch0    = packVarTitle.match(/(\d+)\s*-?\s*pack/i);
    var packSize0     = packMatch0 ? parseInt(packMatch0[1], 10) : 1;
    var isFlavorless0 = (item.product_title || '').toLowerCase().indexOf('flavorless') !== -1;

    /* effectivePacks: for a 1-pack variant with qty=2, the customer has 2 packs — use this
       for OTP tier discounts so qty changes on 1-pack variants trigger the right tier. */
    var effectivePacks0 = packSize0 * item.quantity;
    var otpDiscPct0 = 0;
    if (isFlavorless0) {
      if      (effectivePacks0 >= 3) otpDiscPct0 = 0.10;
      else if (effectivePacks0 >= 2) otpDiscPct0 = 0.05;
    } else {
      if      (effectivePacks0 >= 5) otpDiscPct0 = 0.10;
      else if (effectivePacks0 >= 3) otpDiscPct0 = 0.05;
    }

    var subDiscPct0 = 0.20; /* default: 1-pack */
    if (isFlavorless0) {
      if      (packSize0 >= 3) subDiscPct0 = 0.30;
      else if (packSize0 >= 2) subDiscPct0 = 0.25;
    } else {
      if      (packSize0 >= 5) subDiscPct0 = 0.30;
      else if (packSize0 >= 3) subDiscPct0 = 0.25;
    }

    /* Full retail per-unit. For subs use selling_plan compare_at; for OTP use variant price.
       compare_at_price in cart JSON is the variant compare-at from Shopify admin (may be 0). */
    var spCompareUnit = isSub && item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price
      ? item.selling_plan_allocation.compare_at_price : 0;
    var shopifyCompare = item.compare_at_price || 0;
    var fullUnit0 = spCompareUnit > 0 ? spCompareUnit
      : (shopifyCompare > item.original_price ? shopifyCompare : item.original_price);
    var fullLine0 = fullUnit0 * item.quantity;

    /* OTP displayed price after tier discount */
    var displayLinePrice0 = (otpDiscPct0 > 0 && !isSub)
      ? Math.round(fullLine0 * (1 - otpDiscPct0))
      : item.final_line_price;

    var upsellHtml = '';
    if (!isSub) {
      /* Determine whether to show the upsell and which sub tier saving to advertise.
         Rules:
           1-pack flavorless : show at qty 1 (20%), 2 (25%), 3 (30%) — hide at qty 4+
           1-pack flavored   : show at qty 1 (20%), 3 (25%), 5 (30%) — hide at all other qtys
           multi-pack variant: show only at qty 1, using that pack-size sub tier — hide at qty 2+ */
      var showUpsell       = false;
      var upsellSubDiscPct = 0.20;
      if (packSize0 === 1) {
        if (isFlavorless0) {
          if      (item.quantity === 1) { showUpsell = true; upsellSubDiscPct = 0.20; }
          else if (item.quantity === 2) { showUpsell = true; upsellSubDiscPct = 0.25; }
          else if (item.quantity === 3) { showUpsell = true; upsellSubDiscPct = 0.30; }
        } else {
          if      (item.quantity === 1) { showUpsell = true; upsellSubDiscPct = 0.20; }
          else if (item.quantity === 3) { showUpsell = true; upsellSubDiscPct = 0.25; }
          else if (item.quantity === 5) { showUpsell = true; upsellSubDiscPct = 0.30; }
        }
      } else {
        /* Multi-pack variants — only valid pack sizes that have a sub equivalent */
        var validMultiPacks = isFlavorless0 ? [2, 3] : [3, 5];
        if (validMultiPacks.indexOf(packSize0) !== -1 && item.quantity === 1) {
          showUpsell       = true;
          upsellSubDiscPct = subDiscPct0; /* already set correctly based on packSize0 */
        }
      }
      if (showUpsell) {
        var subFirstOrderLine = Math.round(fullLine0 * (1 - upsellSubDiscPct));
        var totalSaving = displayLinePrice0 - subFirstOrderLine;
        if (totalSaving <= 0) totalSaving = Math.round(displayLinePrice0 * upsellSubDiscPct);
        upsellHtml =
          '<div class="ycd-upsell">' +
            '<span class="ycd-upsell-text">Save <strong>' + fmt(totalSaving) + '</strong> — switch to a subscription</span>' +
            '<button type="button" class="ycd-upsell-btn" data-variant="' + item.variant_id + '" data-key="' + item.key + '" data-qty="' + item.quantity + '" data-handle="' + item.handle + '">Switch</button>' +
          '</div>';
      }
    }

    /* Frequency dropdown for subs */
    var freqHtml = '';
    if (isSub) {
      var planId    = String(item.selling_plan_allocation.selling_plan.id);
      var plans     = getPlans(packSize0, isFlavorless0);

      /* Get the actual label from the cart item — this is always correct regardless of which
         Smartrr discount group the plan belongs to */
      var actualPlanName = item.selling_plan_allocation.selling_plan.name || '';
      /* Extract just the frequency part (e.g. "Every 4 Weeks" from "Delivery Every 4 Weeks - Save 20%") */
      var freqMatch = actualPlanName.match(/every\s+\d+\s+weeks/i);
      var actualFreqLabel = freqMatch ? freqMatch[0].replace(/\b\w/g, function(c){ return c.toUpperCase(); }) : '';

      /* Try to match by ID first, then by frequency label */
      var planLabel = actualFreqLabel || (plans[0] ? plans[0].label : 'Every 4 Weeks');
      var matchedPlanId = planId;
      plans.forEach(function(p) {
        if (p.id === planId) { planLabel = p.label; matchedPlanId = p.id; }
      });
      /* If no ID match, find the plan with the same frequency label */
      if (matchedPlanId === planId && actualFreqLabel) {
        plans.forEach(function(p) {
          if (p.label.toLowerCase() === actualFreqLabel.toLowerCase()) { matchedPlanId = p.id; planLabel = p.label; }
        });
      }

      var liHtml = plans.map(function(p) {
        var isActive = (p.id === matchedPlanId) || (p.label.toLowerCase() === planLabel.toLowerCase());
        return '<li class="' + (isActive ? 'active' : '') + '" data-plan-id="' + p.id + '">' + p.label + '</li>';
      }).join('');
      freqHtml =
        '<div class="ycd-freq-wrap">' +
          '<span class="ycd-freq-label">Ships</span>' +
          '<div class="ycd-freq-dd" data-key="' + item.key + '">' +
            '<button type="button" class="ycd-freq-trigger">' +
              '<span class="ycd-freq-cur">' + planLabel + '</span>' +
              '<svg class="ycd-freq-chevron" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><circle cx="11" cy="11" r="10" stroke="rgba(255,255,255,0.5)" stroke-width="1.5"/><path d="M7.5 9.5L11 13L14.5 9.5" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>' +
            '<ul class="ycd-freq-list">' + liHtml + '</ul>' +
          '</div>' +
        '</div>';
    }

    /* Bottom row */
    var bottomHtml = isSub
      ? '<button class="ycd-remove-sub" data-key="' + item.key + '" data-qty="' + item.quantity + '">Remove</button>'
      : '<div class="ycd-item-bottom">' +
          '<div class="ycd-qty">' +
            '<button type="button" class="ycd-qty-minus" data-key="' + item.key + '">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" class="ycd-qty-plus"  data-key="' + item.key + '">+</button>' +
          '</div>' +
          '<button class="ycd-remove" data-key="' + item.key + '">Remove</button>' +
        '</div>';

    /* ── Card prices — reuse shared pack vars ── */
    var compareLinePrice = 0;
    var lineDiscount     = 0;
    var displayLinePrice = item.final_line_price;

    if (isSub) {
      /* Sub: use selling_plan compare_at (full retail) > variant compare_at > estimated from sub tier */
      if (spCompareUnit > 0) {
        compareLinePrice = spCompareUnit * item.quantity;
      } else if (shopifyCompare > item.final_price) {
        compareLinePrice = shopifyCompare * item.quantity;
      }
      if (compareLinePrice === 0) {
        /* Estimate full retail by reversing the sub tier discount */
        compareLinePrice = Math.round(item.final_line_price / (1 - subDiscPct0));
      }
      lineDiscount = compareLinePrice - item.final_line_price;
    } else if (otpDiscPct0 > 0) {
      /* OTP multi-pack: use pre-computed fullLine0 and otpDiscPct0 */
      compareLinePrice = fullLine0;
      lineDiscount     = Math.round(fullLine0 * otpDiscPct0);
      displayLinePrice = displayLinePrice0; /* = fullLine0 * (1 - otpDiscPct0) */
    } else if (item.original_line_price > item.final_line_price) {
      /* Fallback: Shopify-applied discount */
      compareLinePrice = item.original_line_price;
      lineDiscount     = item.original_line_price - item.final_line_price;
    }

    var compareHtml = compareLinePrice > 0
      ? '<span class="ycd-item-compare">' + fmt(compareLinePrice) + '</span>' : '';
    var savePillHtml = lineDiscount > 0
      ? '<span class="ycd-save-pill">SAVE ' + fmt(lineDiscount) + '</span>' : '';

    /* Free shipping badge — always for subs; for OTP render hidden, revealed by renderCart */
    var freeShipHtml = '';
    if (isSub) {
      freeShipHtml = '<div class="ycd-free-ship">✓ Free Shipping</div>';
    } else {
      freeShipHtml = '<div class="ycd-free-ship ycd-otp-free-ship" style="display:none;">✓ Free Shipping</div>';
    }

    el.innerHTML =
      (isSub ? '<div class="ycd-sub-header">Subscription</div>' : '<div class="ycd-otp-header">One-Time Purchase</div>') +
      (savePillHtml || '') +
      '<div class="ycd-item-top">' +
        '<img src="' + (img || '') + '" alt="' + item.product_title + '" loading="lazy">' +
        '<div class="ycd-item-info">' +
          '<div class="ycd-item-title">' + item.product_title + '</div>' +
          '<div class="ycd-item-meta">' +
            variantBadge +
            '<span class="ycd-item-price">' + fmt(displayLinePrice) + '</span>' +
            compareHtml +
          '</div>' +
          freeShipHtml +
        '</div>' +
      '</div>' +
      freqHtml +
      bottomHtml +
      upsellHtml;

    return el;
  }

  /* ── Selling plans — keyed by discount tier ── */
  var PLAN_TIERS = {
    '20pct': [
      { id: '2758246463', label: 'Every 2 Weeks'  }, { id: '2754314303', label: 'Every 4 Weeks'  },
      { id: '2758279231', label: 'Every 6 Weeks'  }, { id: '2754347071', label: 'Every 8 Weeks'  },
      { id: '2758311999', label: 'Every 10 Weeks' }, { id: '2754379839', label: 'Every 12 Weeks' },
      { id: '2754412607', label: 'Every 16 Weeks' }
    ],
    '25pct': [
      { id: '2758344767', label: 'Every 2 Weeks'  }, { id: '2754445375', label: 'Every 4 Weeks'  },
      { id: '2758377535', label: 'Every 6 Weeks'  }, { id: '2754478143', label: 'Every 8 Weeks'  },
      { id: '2758410303', label: 'Every 10 Weeks' }, { id: '2754510911', label: 'Every 12 Weeks' },
      { id: '2754543679', label: 'Every 16 Weeks' }
    ],
    '30pct': [
      { id: '2758443071', label: 'Every 2 Weeks'  }, { id: '2754576447', label: 'Every 4 Weeks'  },
      { id: '2758475839', label: 'Every 6 Weeks'  }, { id: '2754609215', label: 'Every 8 Weeks'  },
      { id: '2758508607', label: 'Every 10 Weeks' }, { id: '2754641983', label: 'Every 12 Weeks' },
      { id: '2754674751', label: 'Every 16 Weeks' }
    ]
  };

  function getTierKey(packSize, isFlavorless) {
    if (isFlavorless) {
      if (packSize >= 3) return '30pct';
      if (packSize >= 2) return '25pct';
    } else {
      if (packSize >= 5) return '30pct';
      if (packSize >= 3) return '25pct';
    }
    return '20pct';
  }

  /* Returns plan list for the correct discount tier.
     Tries live Smartrr DOM first; falls back to hardcoded tier table. */
  function getPlans(packSize, isFlavorless) {
    var plans = [];
    var tierKey = getTierKey(packSize, isFlavorless);
    var tierPlanIds = {};
    (PLAN_TIERS[tierKey] || PLAN_TIERS['20pct']).forEach(function(p) { tierPlanIds[p.id] = true; });

    document.querySelectorAll('[data-smartrr-selling-plan-group-id]:not(.smartrr-otp)').forEach(function(g) {
      if (plans.length) return;
      var sel = g.querySelector('select');
      if (sel) {
        var tierPlans = [];
        for (var i = 0; i < sel.options.length; i++) {
          var pid = sel.options[i].value;
          if (tierPlanIds[pid]) tierPlans.push({ id: pid, label: sel.options[i].textContent.trim() });
        }
        if (tierPlans.length) plans = tierPlans;
      }
    });
    if (plans.length) {
      plans.sort(function(a, b) {
        return (parseInt(a.label.replace(/\D/g,''),10)||0) - (parseInt(b.label.replace(/\D/g,''),10)||0);
      });
      plans = plans.filter(function(p) { var w = parseInt(p.label.replace(/\D/g,''), 10); return !isNaN(w) && w <= 12; });
      return plans;
    }
    return PLAN_TIERS[tierKey] || PLAN_TIERS['20pct'];
  }

  /* Pick right default plan based on pack size + flavor:
     Flavorless: 2-pack→8wk, 3+pack→12wk
     Flavored:   3-pack→8wk, 5+pack→12wk, else→4wk */
  function getDefaultPlan(plans, packSize, isFlavorless) {
    var targetWeeks = 4;
    if (isFlavorless) {
      if      (packSize >= 3) targetWeeks = 12;
      else if (packSize >= 2) targetWeeks = 8;
    } else {
      if      (packSize >= 5) targetWeeks = 12;
      else if (packSize >= 3) targetWeeks = 8;
    }
    var match = null;
    plans.forEach(function(p) {
      if (p.label.replace(/\D/g,'').indexOf(String(targetWeeks)) !== -1) match = p;
    });
    return match || plans[0];
  }
  function cartChange(payload) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(r) { return r.json(); });
  }

  function removeItem(key) {
    var card = itemsEl.querySelector('[data-key="' + key + '"]');
    if (card) { card.style.opacity = '0.3'; card.style.pointerEvents = 'none'; }
    cartChange({ id: key, quantity: 0 })
      .then(function(cart) { renderCart(cart); })
      .catch(function() { fetchCart(); });
  }

  var qtyTimers = {};
  function changeQty(key, newQty, card) {
    /* Instant DOM update */
    card.setAttribute('data-qty', newQty);
    var span = card.querySelector('.ycd-qty span');
    if (span) span.textContent = newQty;

    /* Debounce — wait for rapid clicks to settle, then fetch authoritative cart state */
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function() {
      cartChange({ id: key, quantity: newQty })
        .then(function(cart) {
          /* Validate response — cart/change.js can return stale state during rapid clicks.
             If items are missing but we expect them, re-fetch from cart.js instead. */
          if (!cart || !Array.isArray(cart.items)) {
            fetchCart(); return;
          }
          /* If cart came back empty but newQty > 0, something is wrong — re-fetch */
          if (cart.items.length === 0 && newQty > 0) {
            fetchCart(); return;
          }
          renderCart(cart);
        })
        .catch(function() { fetchCart(); });
    }, 500);
  }

  function changePlan(key, planId) {
    /* Silent change — don't re-render, the UI already shows the selection */
    cartChange({ id: key, selling_plan: parseInt(planId, 10) })
      .catch(function() { fetchCart(); }); /* only full refresh on error */
  }

  /* ── Nav badge sync ── */
  function syncNav(count) {
    count = parseInt(count, 10) || 0;
    [
      'cart-count', '[data-cart-count]', '.cart__count', '.cart-count',
      '.site-header__cart-count', '.js-cart-count', '[data-header-cart-count]',
      '.header__cart-count', '[data-cart-bubble]'
    ].forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        el.textContent = count;
        ['data-cart-count','data-count','data-bubble'].forEach(function(a) {
          if (el.hasAttribute(a)) el.setAttribute(a, count);
        });
        el.classList.toggle('is-empty', count === 0);
        el.classList.toggle('has-items', count > 0);
      });
    });
    ['cart:updated','cart:refresh','cart:change'].forEach(function(evt) {
      document.dispatchEvent(new CustomEvent(evt, { detail: { item_count: count } }));
    });
  }

  /* ── Discount code ── */
  discBtn.addEventListener('click', function() {
    var code = discInput.value.trim();
    if (!code) return;
    discBtn.disabled = true; discBtn.textContent = '...';
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { discount_code: code } })
    })
    .then(function() {
      discMsg.textContent = 'Code saved, applied at checkout.';
      discMsg.className = 'ycd-discount-msg success';
      discMsg.style.display = 'block';
      discInput.value = '';
      discBtn.textContent = 'Applied';
      setTimeout(function() { discBtn.textContent = 'Apply'; discBtn.disabled = false; }, 2000);
    })
    .catch(function() {
      discMsg.textContent = 'Could not save. Enter at checkout.';
      discMsg.className = 'ycd-discount-msg error';
      discMsg.style.display = 'block';
      discBtn.textContent = 'Apply'; discBtn.disabled = false;
    });
  });
  discInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') discBtn.click(); });

  /* ── Drawer clicks (delegation) ── */
  drawer.addEventListener('click', function(e) {
    var rem     = e.target.closest('.ycd-remove, .ycd-remove-sub');
    var close_  = e.target.closest('.ycd-close, #ycdContinue');
    var plus    = e.target.closest('.ycd-qty-plus');
    var minus   = e.target.closest('.ycd-qty-minus');
    var trigger = e.target.closest('.ycd-freq-trigger');
    var li      = e.target.closest('.ycd-freq-list li');
    var upsell  = e.target.closest('.ycd-upsell-btn');
    var recAdd  = e.target.closest('.ycd-rec-add');
    var rvdTrig = e.target.closest('.ycd-rvd-trigger');
    var rvdLi   = e.target.closest('.ycd-rvd-list li');

    if (close_) { close(); return; }

    if (recAdd) {
      var recVarId = recAdd.getAttribute('data-variant');
      if (!recVarId || recAdd.disabled) return;
      /* Remember the real label once, so a retry after a failure doesn't
         permanently rename the button to "Try again" */
      if (!recAdd.getAttribute('data-label')) recAdd.setAttribute('data-label', recAdd.textContent);
      var recOrig = recAdd.getAttribute('data-label') || 'Add';
      var recCard = recAdd.closest('.ycd-rec-card');
      var recName = recCard ? (recCard.getAttribute('data-title') || '') : '';
      function recReset() {
        recAdd.textContent = recOrig; recAdd.disabled = false;
        recAdd.classList.remove('added', 'failed');
      }
      function recFail(label) {
        recAdd.classList.add('failed');
        recAdd.textContent = label;
        recAdd.disabled = false;   /* let them tap it again rather than dead-ending */
        recAnnounce(label + ' — ' + recName + ' was not added.');
        setTimeout(function() {
          if (document.body.contains(recAdd) && recAdd.classList.contains('failed')) recReset();
        }, 4000);
      }
      recAdd.classList.remove('failed');
      recAdd.disabled = true; recAdd.textContent = 'Adding…';
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(recVarId, 10), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status && data.status !== 200) { recFail('Unavailable'); return; }
        recAdd.classList.add('added');
        recAdd.textContent = 'Added ✓';
        recAnnounce(recName + ' added to your cart.');
        recTrack('add_to_cart', {
          item_list_id: 'cart_drawer_upsell',
          item_list_name: 'Cart Drawer Upsell',
          currency: (window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : undefined),
          value: (typeof data.final_line_price === 'number' ? data.final_line_price / 100 : undefined),
          items: [{
            item_id: String(data.product_id || (recCard ? recCard.getAttribute('data-product') : '')),
            item_name: data.product_title || recName,
            item_variant: data.variant_title || '',
            price: (typeof data.final_price === 'number' ? data.final_price / 100 : undefined),
            quantity: 1
          }]
        });
        /* Hold the upsell refresh briefly so the confirmation reads, then slide the row out —
           it's in the cart now, so it drops off the suggestion list */
        recHoldUntil = Date.now() + 1150;
        if (recCard) setTimeout(function() { recCard.classList.add('leaving'); }, 800);
        /* Safety net: if the refresh never lands, put the card back the way it was */
        setTimeout(function() {
          if (!document.body.contains(recAdd)) return;
          recReset();
          if (recCard) recCard.classList.remove('leaving');
        }, 2600);
        fetchCart();
      })
      .catch(function() { recFail('Try again'); });
      return;
    }

    if (rem) {
      var key = rem.getAttribute('data-key');
      var card = rem.closest('.ycd-item');
      if (card) { card.style.opacity = '0.3'; card.style.pointerEvents = 'none'; }
      removeItem(key);
      return;
    }

    if (plus) {
      var card = plus.closest('.ycd-item');
      var qty  = parseInt(card.getAttribute('data-qty') || '1', 10) + 1;
      changeQty(plus.getAttribute('data-key'), qty, card);
      return;
    }

    if (minus) {
      var card = minus.closest('.ycd-item');
      var qty  = parseInt(card.getAttribute('data-qty') || '1', 10) - 1;
      if (qty < 1) {
        card.style.opacity = '0.3'; card.style.pointerEvents = 'none';
        removeItem(minus.getAttribute('data-key'));
      } else {
        changeQty(minus.getAttribute('data-key'), qty, card);
      }
      return;
    }

    if (trigger) {
      e.stopPropagation();
      var dd = trigger.closest('.ycd-freq-dd');
      drawer.querySelectorAll('.ycd-freq-dd.open').forEach(function(d) { if (d !== dd) d.classList.remove('open'); });
      dd.classList.toggle('open');
      return;
    }

    if (li && !li.classList.contains('disabled')) {
      var dd = li.closest('.ycd-freq-dd');
      dd.querySelector('.ycd-freq-cur').textContent = li.textContent.trim();
      dd.querySelectorAll('li').forEach(function(l) { l.classList.remove('active'); });
      li.classList.add('active');
      dd.classList.remove('open');
      if (li.getAttribute('data-plan-id')) changePlan(dd.getAttribute('data-key'), li.getAttribute('data-plan-id'));
      return;
    }

    if (rvdTrig) {
      e.stopPropagation();
      var rdd = rvdTrig.closest('.ycd-rvd');
      drawer.querySelectorAll('.ycd-rvd.open').forEach(function(d) { if (d !== rdd) ycdSetRvd(d, false); });
      drawer.querySelectorAll('.ycd-freq-dd.open').forEach(function(d) { d.classList.remove('open'); });
      ycdSetRvd(rdd, !rdd.classList.contains('open'));
      return;
    }

    if (rvdLi) {
      /* Sold-out sizes stay visible for context but can't be chosen */
      if (rvdLi.getAttribute('aria-disabled') === 'true') { e.stopPropagation(); return; }
      var rdd   = rvdLi.closest('.ycd-rvd');
      var rcard = rvdLi.closest('.ycd-rec-card');
      rdd.querySelector('.ycd-rvd-cur').textContent = rvdLi.textContent.trim();
      rdd.querySelectorAll('li').forEach(function(l) {
        l.classList.remove('active'); l.setAttribute('aria-selected', 'false');
      });
      rvdLi.classList.add('active');
      rvdLi.setAttribute('aria-selected', 'true');
      ycdSetRvd(rdd, false);
      if (rcard) {
        var rvId    = rvdLi.getAttribute('data-variant');
        var rprice  = parseInt(rvdLi.getAttribute('data-price'), 10);
        var rcomp   = parseInt(rvdLi.getAttribute('data-compare') || '0', 10);
        var raddBtn = rcard.querySelector('.ycd-rec-add');
        if (raddBtn) raddBtn.setAttribute('data-variant', rvId);
        var rpriceEl = rcard.querySelector('.ycd-rec-price');
        if (rpriceEl) {
          var rh = '<span class="ycd-rec-amt">' + fmt(rprice) + '</span>';
          if (rcomp && rcomp > rprice) rh += '<span class="ycd-rec-compare">' + fmt(rcomp) + '</span>';
          rpriceEl.innerHTML = rh;
        }
        /* A bigger pack may now clear the free-shipping line (or a smaller one stop
           clearing it) — re-arbitrate across the whole tray, not just this row. */
        rcard.setAttribute('data-price', rprice);
        recSyncShipBadges();
      }
      return;
    }

    if (upsell) {
      var itemKey       = upsell.getAttribute('data-key');
      var currentQty    = parseInt(upsell.getAttribute('data-qty') || '1', 10);
      var currentVar    = upsell.getAttribute('data-variant');
      var productHandle = upsell.getAttribute('data-handle');
      upsell.innerHTML = '<svg style="display:inline-block;vertical-align:middle;animation:ycdSpin .7s linear infinite;margin-right:5px;" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M12 2a10 10 0 0 1 10 10"/></svg>Switching…';
      upsell.disabled = true;

      fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js', { cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(product) {
          var isFlavorless = product.handle.indexOf('flavorless') !== -1;

          var currentVariantData = product.variants.filter(function(v) { return String(v.id) === String(currentVar); })[0];
          var currentVarTitle    = (currentVariantData && currentVariantData.title) ? currentVariantData.title : '';
          var packMatch          = currentVarTitle.match(/(\d+)\s*-?\s*pack/i);
          
          /* NEW CONSOLIDATION LOGIC */
          var basePackSize = packMatch ? parseInt(packMatch[1], 10) : 1;
          var totalPacks   = basePackSize * currentQty;

          var targetVariant = null;
          var addQty = currentQty;
          var packSize = basePackSize; // Fallback pack size for frequency logic

          // 1. Try to find a variant matching the TOTAL packs (e.g., 3 x 1-pack -> 3-pack)
          var exactMatchVariant = product.variants.filter(function(v) {
            return v.title && new RegExp('\\b' + totalPacks + '[\\s\\-]*pack', 'i').test(v.title);
          })[0];

          if (exactMatchVariant) {
            targetVariant = exactMatchVariant;
            addQty = 1; // Reset cart quantity to 1 since it's now a bundled pack
            packSize = totalPacks; // Use the new bundled pack size for frequency logic
          } else {
            // 2. Fall back to original base pack size if no larger bundle exists (e.g., 4 x 1-pack)
            targetVariant = product.variants.filter(function(v) {
              return v.title && new RegExp('\\b' + basePackSize + '[\\s\\-]*pack', 'i').test(v.title);
            })[0];
          }

          var addVariant   = targetVariant || currentVariantData || product.variants[0];
          var addVariantId = addVariant ? addVariant.id : parseInt(currentVar, 10);

          /* Determine target frequency weeks based on pack size + flavor */
          var targetWeeks = 4;
          if (isFlavorless) {
            if      (packSize >= 3) targetWeeks = 12;
            else if (packSize >= 2) targetWeeks = 8;
          } else {
            if      (packSize >= 5) targetWeeks = 12;
            else if (packSize >= 3) targetWeeks = 8;
          }

          /* Build sets of: all plan IDs on this variant, and the correct tier IDs */
          var variantPlanIds = {};
          ((addVariant && addVariant.selling_plan_allocations) || []).forEach(function(a) {
            variantPlanIds[String(a.selling_plan_id)] = true;
          });
          var switchTierKey = getTierKey(packSize, isFlavorless);
          var tierPlanIds   = {};
          (PLAN_TIERS[switchTierKey] || PLAN_TIERS['20pct']).forEach(function(p) {
            tierPlanIds[p.id] = true;
          });

          /* Walk selling_plan_groups — pick the plan that is:
             1. available on the target variant
             2. in the correct discount tier (matching pack size)
             3. has the right frequency (target weeks)
             4. is a sub plan (has a discount) */
          var chosenPlanId = null;
          (product.selling_plan_groups || []).forEach(function(group) {
            if (chosenPlanId) return;
            (group.selling_plans || []).forEach(function(sp) {
              if (chosenPlanId) return;
              if (!variantPlanIds[String(sp.id)]) return;  /* not on this variant */
              if (!tierPlanIds[String(sp.id)]) return;      /* wrong discount tier */
              var alloc = ((addVariant && addVariant.selling_plan_allocations) || [])
                .find(function(a) { return String(a.selling_plan_id) === String(sp.id); });
              if (!alloc || alloc.price >= alloc.compare_at_price) return; /* OTP, skip */
              var wMatch = sp.name.match(/(\d+)\s+week/i);
              if (wMatch && parseInt(wMatch[1], 10) === targetWeeks) {
                chosenPlanId = sp.id;
              }
            });
          });

          if (!chosenPlanId) {
            /* Fallback: pick the first sub alloc in the correct tier */
            var fallbackAlloc = ((addVariant && addVariant.selling_plan_allocations) || [])
              .filter(function(a) { return a.price < a.compare_at_price && tierPlanIds[String(a.selling_plan_id)]; })
              .sort(function(a, b) { return a.selling_plan_id - b.selling_plan_id; })[0];
            /* Widen fallback to any sub alloc if tier filter yields nothing */
            if (!fallbackAlloc) {
              fallbackAlloc = ((addVariant && addVariant.selling_plan_allocations) || [])
                .filter(function(a) { return a.price < a.compare_at_price; })
                .sort(function(a, b) { return a.selling_plan_id - b.selling_plan_id; })[0];
            }
            if (!fallbackAlloc) { upsell.textContent = 'Switch'; upsell.disabled = false; return; }
            chosenPlanId = fallbackAlloc.selling_plan_id;
          }

          return doSwitch(itemKey, addVariantId, addQty, chosenPlanId);
        })
        .catch(function() {
          upsell.textContent = 'Switch'; upsell.disabled = false;
          fetchCart();
        });
      return;
    }

    function doSwitch(itemKey, variantId, qty, planId) {
      return cartChange({ id: itemKey, quantity: 0 })
        .then(function(cart) {
          var stillThere = (cart.items || []).some(function(i) { return i.key === itemKey; });
          if (stillThere) throw new Error('remove failed');
          var addBody = { id: variantId, quantity: qty, selling_plan: planId };
          if (planId) addBody.properties = { _subscription_id: Date.now() + '-' + Math.random().toString(36).substr(2, 6) };
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(addBody)
          });
        })
        .then(function() { fetchCart(); })
        .catch(function() { fetchCart(); });
    }

    if (!e.target.closest('.ycd-freq-dd')) {
      drawer.querySelectorAll('.ycd-freq-dd.open').forEach(function(d) { d.classList.remove('open'); });
    }
    if (!e.target.closest('.ycd-rvd')) {
      drawer.querySelectorAll('.ycd-rvd.open').forEach(function(d) { ycdSetRvd(d, false); });
    }
  });

  /* ── Keyboard: Escape closes the open dropdown first, then the drawer.
        Arrows move through the size list the way a native select does. ── */
  document.addEventListener('keydown', function(e) {
    if (!drawer.classList.contains('open')) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      var openRvd  = drawer.querySelector('.ycd-rvd.open');
      var openFreq = drawer.querySelector('.ycd-freq-dd.open');
      if (openRvd) {
        ycdSetRvd(openRvd, false);
        var t = openRvd.querySelector('.ycd-rvd-trigger');
        if (t) t.focus();
        e.preventDefault();
        return;
      }
      if (openFreq) { openFreq.classList.remove('open'); e.preventDefault(); return; }
      close();
      return;
    }

    var inRvd = e.target && e.target.closest ? e.target.closest('.ycd-rvd') : null;
    if (!inRvd) return;

    if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !inRvd.classList.contains('open')) {
      ycdSetRvd(inRvd, true);
      e.preventDefault();
      return;
    }
    if (!inRvd.classList.contains('open')) return;

    var opts = Array.prototype.slice.call(inRvd.querySelectorAll('.ycd-rvd-list li'))
      .filter(function(l) { return l.getAttribute('aria-disabled') !== 'true'; });
    if (!opts.length) return;
    var cur = opts.indexOf(inRvd.querySelector('.ycd-rvd-list li.ycd-kb'));
    if (cur === -1) cur = opts.indexOf(inRvd.querySelector('.ycd-rvd-list li.active'));

    function mark(i) {
      inRvd.querySelectorAll('.ycd-rvd-list li.ycd-kb').forEach(function(l) { l.classList.remove('ycd-kb'); });
      opts[i].classList.add('ycd-kb');
      opts[i].scrollIntoView({ block: 'nearest' });
    }

    if (e.key === 'ArrowDown')      { mark(Math.min(opts.length - 1, cur + 1)); e.preventDefault(); }
    else if (e.key === 'ArrowUp')   { mark(Math.max(0, cur <= 0 ? 0 : cur - 1)); e.preventDefault(); }
    else if (e.key === 'Home')      { mark(0); e.preventDefault(); }
    else if (e.key === 'End')       { mark(opts.length - 1); e.preventDefault(); }
    else if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      if (cur > -1) { opts[cur].click(); e.preventDefault(); }
    }
  });

  /* (Recommendation variant switching is handled in the drawer click delegation above.) */

  /* ── Discount accordion toggle ── */
  var discToggle = document.getElementById('ycdDiscountToggle');
  var discBody   = document.getElementById('ycdDiscountBody');
  discToggle.addEventListener('click', function() {
    var open = discBody.classList.toggle('open');
    discToggle.classList.toggle('open', open);
    if (open) document.getElementById('ycdDiscountInput').focus();
  });

  overlay.addEventListener('click', close);
  window.yonderCartDrawer = { open: open, close: close };

  /* ── Suppress theme cart drawer ── */
  function suppressTheme() {
    var td = document.getElementById('cart-drawer');
    if (td && typeof td.open === 'function') td.open = function() {};
    document.addEventListener('cart:open', function(e) { e.stopImmediatePropagation(); open(); }, true);
  }
  document.readyState !== 'loading' ? suppressTheme() : document.addEventListener('DOMContentLoaded', suppressTheme);

  /* ── ATC intercept ── */
  document.addEventListener('ajaxProduct:added', function() { open(); });

  document.addEventListener('click', function(e) {
    var t = e.target.closest(
      '.js-drawer-open-cart,[data-cart-toggle],[data-drawer="cart-drawer"],' +
      '.site-header__cart,[aria-controls="cart-drawer"],' +
      'a[href="/cart"]:not(#ycdCheckoutBtn):not(.ycd-checkout)'
    );
    if (t && !e.target.closest('#yonder-cart-drawer')) {
      e.preventDefault(); e.stopImmediatePropagation(); open();
    }
  }, true);

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[name="add"],button[data-add-to-cart]');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding...';
    var fd = new FormData(form);
    /* Unique property so Shopify never merges subscription line items */
    if (form.querySelector('input[name="selling_plan"]') && form.querySelector('input[name="selling_plan"]').value) {
      fd.append('properties[_subscription_id]', Date.now() + '-' + Math.random().toString(36).substr(2, 6));
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: fd
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      btn.disabled = false;
      if (data.status && data.status !== 200) {
        btn.textContent = data.description || 'Error';
        setTimeout(function() { btn.textContent = orig; }, 3000);
        return;
      }
      btn.textContent = 'Added!';
      setTimeout(function() { btn.textContent = orig; }, 2000);
      document.dispatchEvent(new CustomEvent('cart:build'));
      drawer.classList.contains('open') ? fetchCart() : open();
    })
    .catch(function() { btn.disabled = false; btn.textContent = 'Error'; setTimeout(function() { btn.textContent = orig; }, 2500); });
  }, true);

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = form.querySelector('[name="add"]');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    var fd = new FormData(form);
    if (form.querySelector('input[name="selling_plan"]') && form.querySelector('input[name="selling_plan"]').value) {
      fd.append('properties[_subscription_id]', Date.now() + '-' + Math.random().toString(36).substr(2, 6));
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: fd
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (btn) btn.disabled = false;
      if (data.status && data.status !== 200) {
        if (btn) { btn.textContent = data.description || 'Error'; setTimeout(function() { btn.textContent = orig; }, 3000); }
        return;
      }
      if (btn) { btn.textContent = 'Added!'; setTimeout(function() { btn.textContent = orig; }, 2000); }
      document.dispatchEvent(new CustomEvent('cart:build'));
      drawer.classList.contains('open') ? fetchCart() : open();
    })
    .catch(function() { if (btn) { btn.disabled = false; btn.textContent = 'Error'; setTimeout(function() { btn.textContent = orig; }, 2500); } });
  }, true);

})();
